// extracted by mini-css-extract-plugin
export default {"component":"AchievementsBody_component__NYanZ","container":"AchievementsBody_container__0VENf"};